export const IconFacebook = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 16.0588C32 7.18983 24.8365 0 16 0C7.16352 0 0 7.18983 0 16.0588C0 23.5897 5.16608 29.9091 12.135 31.6448V20.9663H8.83584V16.0588H12.135V13.9442C12.135 8.47839 14.5997 5.94496 19.9462 5.94496C20.96 5.94496 22.7091 6.14473 23.4246 6.34386V10.7921C23.047 10.7523 22.391 10.7324 21.5763 10.7324C18.953 10.7324 17.9392 11.73 17.9392 14.3231V16.0588H23.1654L22.2675 20.9663H17.9392V32C25.8618 31.0397 32 24.2693 32 16.0588Z"
      fill="currentColor"
    />
  </svg>
);